import React from 'react';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-surface pt-20 pb-10 border-t-2 border-gold relative z-20" data-id="element-18" data-mp="3ggarzyv0aj71">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-19" data-mp="32oe1fz8zkhcr">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-20" data-mp="32lrm3dfusxjz">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-21" data-mp="36nd5lhmw8a35">
            <a href="#" className="font-serif text-3xl font-bold tracking-widest block mb-6 text-ink" data-id="element-22" data-mp="3uesbtlhsjbjo">
              LUMIÈRE{' '}
              <span className="text-gold-deep font-light text-2xl" data-id="element-23" data-mp="3lem1u9lawtp9">DENTAL</span>
            </a>
            <p className="font-sans text-ink-soft text-sm max-w-sm leading-relaxed" data-id="element-24" data-mp="3qdf3n4r86w9l">
              Redefiniendo la odontología moderna a través del arte, la
              tecnología y el confort absoluto. Tu sonrisa es nuestra obra
              maestra.
            </p>
          </div>

          {/* Contact */}
          <div data-id="element-25" data-mp="3l90m9rokaqx5">
            <h4 className="font-serif text-ink text-lg mb-6" data-id="element-26" data-mp="3l8qxu8j60rtk">Contacto</h4>
            <ul className="space-y-4 font-sans text-sm text-ink-soft" data-id="element-27" data-mp="3gapb9dmj6adc">
              <li className="flex items-start gap-3" data-id="element-28" data-mp="3gck196cnssoa">
                <MapPin size={18} className="text-gold-deep shrink-0 mt-0.5" data-id="element-29" data-mp="3v8rh5uh1b7xr" />
                <span data-id="element-30" data-mp="3q83tnis0l98a">
                  Av. Libertador 1234, Piso 5<br data-id="element-31" data-mp="3q7bxo6ui99hh" />
                  Buenos Aires, Argentina
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-32" data-mp="80xjc6sbqxik">
                <Phone size={18} className="text-gold-deep shrink-0" data-id="element-33" data-mp="34p6x15ihif3" />
                <span data-id="element-34" data-mp="hsk3ismn46xg">+54 9 299 519-2151</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-35" data-mp="hs1vyzuj26a8">
                <Mail size={18} className="text-gold-deep shrink-0" data-id="element-36" data-mp="ctgvr0f9zmls" />
                <span data-id="element-37" data-mp="qthyymj0j64f">vip@lumieredental.com</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div data-id="element-38" data-mp="mspndmmo4p4z">
            <h4 className="font-serif text-ink text-lg mb-6" data-id="element-39" data-mp="msy45plwwelg">Síguenos</h4>
            <div className="flex gap-4" data-id="element-40" data-mp="tvmqpiubmimf">
              <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-gold-wash border border-line flex items-center justify-center text-gold-deep hover:bg-gold hover:text-ink transition-colors duration-300" data-id="element-41" data-mp="two3psuwdf6s">
                <Instagram size={20} data-id="element-42" data-mp="18ksn6z1rxuqm" />
              </a>
              <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-gold-wash border border-line flex items-center justify-center text-gold-deep hover:bg-gold hover:text-ink transition-colors duration-300" data-id="element-43" data-mp="1cluodlf94gv8">
                <Facebook size={20} data-id="element-44" data-mp="1riv5yw3qavfz" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-line pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-45" data-mp="3ob551yhw6t30">
          <p className="font-sans text-xs text-ink-soft" data-id="element-46" data-mp="3t9ym20we127x">
            &copy; {new Date().getFullYear()} Lumière Dental. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6 font-sans text-xs text-ink-soft" data-id="element-47" data-mp="2agygtddldbrx">
            <a href="#" className="hover:text-gold-deep transition-colors" data-id="element-48" data-mp="25n3xib1weytd">
              Políticas de Privacidad
            </a>
            <a href="#" className="hover:text-gold-deep transition-colors" data-id="element-49" data-mp="1wnp8lg1dqwaz">
              Términos de Servicio
            </a>
          </div>
        </div>
      </div>
    </footer>;
}